export default class UserError extends Error {}
